import PocketBase from "pocketbase";

// export const pb = new PocketBase("https://204.168.151.122:8090");

export const pb = new PocketBase("https://vsichkibroshuri.com/pb");
export const API_BASE_URL = "https://vsichkibroshuri.com"

pb.autoCancellation(false);
